export const getQuizs = (state) => state.quizs
export const getQuiz = (state) => (question_id) => state.quizs.find(x => x.id === question_id) || {}
export const getQuizsMeta = (state) => state.meta_data


